import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'search',
    standalone: false
})
export class SearchPipe implements PipeTransform {

  transform(customerList: any[], searchTxt: string): any {
    if(!customerList || !customerList.length) return customerList;
    if(!searchTxt || !searchTxt.length) return customerList;
    return customerList.filter(item => {
      return item.customerName.toString().toLowerCase().indexOf(searchTxt.toLowerCase()) > -1
    });
  }

}
